export default __webpack_public_path__ + "static/media/SAND_TEXTBOX.ffa2903f.png";